module.exports = __webpack_public_path__ + "static/img/9.3822e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/9.png
// module id = yznN
// module chunks = 35